import { PDFDocument } from "pdf-lib";

/**
 * Combines an array of image URLs or File/Blob objects into a single PDF Blob.
 * @param images Array of image URLs (string) or File/Blob objects
 * @returns Promise<Blob> - PDF Blob
 */
export async function createPdfFromImages(
  images: (string | File | Blob)[]
): Promise<Blob> {
  const pdfDoc = await PDFDocument.create();

  for (const imgSrc of images) {
    let imgBytes: ArrayBuffer;
    if (typeof imgSrc === "string") {
      imgBytes = await fetch(imgSrc).then((res) => res.arrayBuffer());
    } else {
      imgBytes = await (imgSrc as Blob).arrayBuffer();
    }

    let img;
    // Try PNG first, fallback to JPG
    if (
      (typeof imgSrc === "string" && imgSrc.toLowerCase().includes("png")) ||
      (typeof imgSrc !== "string" && (imgSrc as File).type === "image/png")
    ) {
      img = await pdfDoc.embedPng(imgBytes);
    } else {
      img = await pdfDoc.embedJpg(imgBytes);
    }

    const page = pdfDoc.addPage([img.width, img.height]);
    page.drawImage(img, { x: 0, y: 0, width: img.width, height: img.height });
  }

  const pdfBytes = await pdfDoc.save();
  return new Blob([new Uint8Array(pdfBytes)], { type: "application/pdf" });
}
